import { APIProvider } from "@vis.gl/react-google-maps";
import React, { ReactNode } from "react";
import { createFastContext } from "../createFastContext";
import { CENTER_DEFAULT, limitShowZoom, ZOOM_DEFAULT } from "./constants";

interface IState {
    zoom: number,
    center: { lat: number, lng: number },
    hideLabel: boolean,
    location?: [number, number]
    zones?: { [id: string]: any[] }
    zonesLock?: boolean
}

const { Provider, useStore: useWorldMap, setStore: setWorldMap, getStore: getWorldMap } = createFastContext<IState>({
    zoom: ZOOM_DEFAULT,
    center: CENTER_DEFAULT,
    hideLabel: ZOOM_DEFAULT < limitShowZoom
});

const WorldMapProvider: React.FC<{
    children: ReactNode,
} & Partial<IState>> = ({ children, ...props }) => {

    return <Provider props={props}>
        <APIProvider apiKey={process.env.REACT_APP_MAP_API_KEY || ''}>
            {children}
        </APIProvider>
    </Provider>
}


export { getWorldMap, setWorldMap, useWorldMap, WorldMapProvider };

